import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, has, orderBy } from 'lodash';
import Map from '@bd/bdui-coremap';
// import POIMap from '@bd/bdui-poimap';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import Lightbox from '@bd/bdui-lightbox';
import { buildThumbnailUrl, GoogleMapUrl, SanitizeHtml, SmoothLink } from '@bd/bdcore-utilities';
import numeral from 'numeral';

import PageHelmet from '@bd/bdcore-pagehelmet';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import HomeCard from '../HomesOriginal/HomeCard';
import PlanCard from '../Plans/PlanCard';
import ContactModal from '../../components/ContactModal';
// import SitePlanModal from './SitePlanModal';
import ShareThis from '../../components/ShareThis';
import CommunityAgent from './CommunityAgent';
import CommunitySitePlan from './CommunitySitePlan';

class CommunityDetail extends React.Component {
  constructor(props) {
    super(props);

    const increment = 500;
    this.state = {
      increment,
      limit: increment,
    };

    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    this.setState({
      limit: this.state.limit + Infinity,
    });
  }

  render() {
    const { community, homes, plans } = this.props;
    const directionMarkers = [
      community,
    ];

    if (get(community, 'outOfCommunity.checked')) {
      directionMarkers.push({ _id: 'salesOffice', ...get(community, 'outOfCommunity'), type: 'salesOffice' });
    }

    const background = {};
    if (has(community, 'photos[0].contentUrl')) {
      background.backgroundImage = buildThumbnailUrl(get(community, 'photos[0].contentUrl'), { width: 1000, height: 1000 });
    } else {
      background.backgroundImage = '/images/comming-soon.jpg';
    }


    return (
      <div className="CommunityDetail">
        <PageHelmet community={community} />
        <Header />
        <div>
          <div className="detail-header">
            <div className="container">
              <div>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link name="index">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link name="communities">Communities</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{get(community, 'name')}</li>
                  </ol>
                </nav>
              </div>
              <div className="row detail-header-inner">
                <div className="col-md-5 detail-header-content">
                  <h1>{get(community, 'name')}</h1>
                  <h3>{`${get(community, 'address.addressLocality')}, ${get(community, 'address.addressRegion')}`}</h3>
                  {
                    (
                      !!get(community, 'priceHigh')
                      || !!get(community, 'priceLow')
                    ) &&
                    <h3>
                      Price Range: {' '}
                      {
                        !!get(community, 'priceLow') &&
                        numeral(get(community, 'priceLow', '')).format('$0,0')
                      }
                      {
                        !!get(community, 'priceHigh') &&
                        !!get(community, 'priceLow') &&
                        ' - '
                      }
                      {
                        !!get(community, 'priceHigh') &&
                        numeral(get(community, 'priceHigh', '')).format('$0,0')
                      }
                    </h3>
                  }
                  {
                    !!get(community, 'headline') &&
                    <div>
                      <h3 className="detail-headline">{get(community, 'headline')}</h3>
                    </div>
                  }
                  <ul className="detail-header-list1">
                    {
                      homes.length > 0 &&
                      <li><SmoothLink href="#homes">Quick Move-In Homes</SmoothLink></li>
                    }
                    <li><SmoothLink href="#plans">Floor Plans</SmoothLink></li>
                    <li><SmoothLink href="#photos">Photos</SmoothLink></li>
                    <li><SmoothLink href="#overview">Community Overview</SmoothLink></li>
                    {
                      get(community, 'zplatpublished') &&
                      <li><SmoothLink href="#siteplan">Site Plan</SmoothLink></li>
                    }
                    {/* {
                      !!get(community, 'poimap') &&
                      <li><SmoothLink href="#poi">Area Map</SmoothLink></li>
                    } */}
                    <li className="d-none d-md-inline-block"><SmoothLink href="#map">Map & Directions</SmoothLink></li>
                    <li className="d-none d-md-inline-block"><ShareThis>Share This Page</ShareThis></li>
                    <li><ContactModal className="btn btn-hollow ml-auto">Schedule A Showing</ContactModal></li>
                  </ul>
                </div>

                <div className="col-md-7 detail-header-media" style={{ backgroundImage: `url('${background.backgroundImage}')` }}>
                  {
                    get(community, 'photos').length > 1 &&
                    <Lightbox
                      items={get(community, 'photos', [])}
                      button={(
                        <a className="detail-media-photo-counter">
                          <img src="/images/icon-camera.svg" alt="Camera Icon" /><br />
                          {get(community, 'photos', []).length}
                        </a>
                      )}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          homes.length > 0 &&
          <div className="additional-homes" id="homes">
            <div className="full-width-headline">
              <h3>Quick Move-In Homes</h3>
              <div className="lines" />
            </div>
            <div className="list-background-color">
              <div className="container">
                <div className="row HomeCardsList Vertical">
                  {
                    homes.map(home => (
                      <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-3" key={home._id}>
                        <HomeCard home={home} key={home._id} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        }

        {
          plans.length > 0 &&
          <div className="additional-homes" id="plans">
            <div className="full-width-headline">
              <h3>{get(community, 'name')} Floor Plans</h3>
              <div className="lines" />
            </div>
            <div className="list-background-color">
              <div className="container">
                <div className="row HomeCardsList Vertical">
                  {
                    orderBy(plans, 'name', 'asc').map(plan => (
                      <PlanCard community={community} plan={plan} key={plan._id} />
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        }

        {
          get(community, 'photos') &&
          <div className="CommunityGallery_wrapper" id="photos">
            <div className="container">
              <h3 className="underdog">Photos</h3>
              <Lightbox items={get(community, 'photos', [])} >
                <ul className="PhotoList_list">
                  {
                    get(community, 'photos').map((photo, index) => {
                      return (
                        <li className="PhotoList_item" key={photo.contentUrl} data-index={index}>
                          <span data-index={index}>
                            {
                              photo.caption &&
                              <div className="PhotoList_imageTitle" data-index={index}>
                                {photo.caption}
                              </div>
                            }
                            {
                              photo &&
                              <div className="PhotoList_image" style={{ backgroundImage: `url('${buildThumbnailUrl(photo.contentUrl, { width: 400, height: 400 })}')` }} data-index={index} />
                            }
                          </span>
                        </li>
                      );
                    })
                  }
                </ul>
              </Lightbox>
            </div>
          </div>
        }
        {
          get(community, 'zplatpublished') &&
          <div className="CommunitySitePlan_wrapper" id="siteplan">
            <div className="container">
              <h3 className="underdog">Site Plan</h3>
              <CommunitySitePlan community={community} />

            </div>
          </div>
        }

        <CommunityAgent community={community} />

        <div id="overview" className="detail-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-8 mx-auto">
                <h4 className="text-center">Explore {get(community, 'name')}</h4>
                <p className="big-p text-center" dangerouslySetInnerHTML={SanitizeHtml(get(community, 'description'))} />
              </div>
            </div>
          </div>
        </div>
        <div className="detail-map-section" id="map">
          <div className="container MapDirection">
            <div className="MapDirection_map">
              <Map
                className={css`
                  height: 100%;
                  .leaflet-container {
                    height: 100%;
                  }
                `}
                pin={{
                  iconUrl: '/images/icon-map-pin-blue.svg',
                }}
                markers={directionMarkers}
              />
            </div>
            <div className="MapDirection_direction">
              <h4>Driving Directions</h4>
              <p>
                {get(community, 'directions')}
              </p>
              <p>
                <a href={GoogleMapUrl(community, 16)} rel="noopener noreferrer" target="_blank">
                  <img src="/images/icon-map-pin-blue.svg" alt="Map Pin" /> Map This Community
                </a>
              </p>
              {
                get(community, 'outOfCommunity.checked') &&
                <div>
                  <h4>Sales Office</h4>
                  <p>
                    {get(community, 'outOfCommunity.address.streetAddress')} <br />
                    {get(community, 'outOfCommunity.address.addressLocality')},{' '}
                    {get(community, 'outOfCommunity.address.addressRegion')}{' '}
                    {get(community, 'outOfCommunity.address.postalCode')}
                  </p>
                  <p>
                    <a href={GoogleMapUrl(get(community, 'outOfCommunity'), 16)} rel="noopener noreferrer" target="_blank">
                      <img src="/images/map-pin-blue.svg" alt="Map Pin" /> Map This Sales Office
                    </a>
                  </p>
                </div>
              }
            </div>
          </div>
        </div>
        <CtaBanner />
        <TestimonialBanner />
        <Footer />
      </div>
    );
  }
}

CommunityDetail.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
};

CommunityDetail.defaultProps = {
  homes: [],
  plans: [],
  area: undefined,
};

export default withData(
  {
    area: true,
    community: true,
    homes: true,
    plans: true,
  },
  {
    ifMissing404: true,
  },
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunityDetail.js